export enum FilterParamsEnum {
  STATUS = 'status',
  PROFILE_ID = 'profile-id',
  START_DATE = 'start-date',
  END_DATE = 'end-date',
  ORGANIZATIONAL_GROUP = 'organizational-group',
  CONTRACT_TYPE = 'contract-type',
  PLAN_TYPE = 'plan-type',
}
